import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// React Flow's stylesheet is global (.react-flow__*). Without it the canvas
// collapses to 0×0 and drag-and-drop / node positioning break. Import here so
// it loads once and survives component refactors (it was lost when the original
// WorkflowStudio was split in PR #64).
import '@xyflow/react/dist/style.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
